import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { LinkifyPipe } from '@iot-platform/pipes';

@Component({
  imports: [FlexLayoutModule, MatProgressSpinner, MatTooltip, LinkifyPipe],
  selector: 'iot-platform-ui-detail-popup-display-property',
  templateUrl: './detail-popup-display-property.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-popup-display-property.component.scss']
})
export class DetailPopupDisplayPropertyComponent {
  property = input<string>();
  value = input<string | number>();
  margin = input<string>();
  loading = input<boolean>(false);
}
